import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { FormikInput } from '../../../components';

export default function TotalValues() {
  const { values } = useFormikContext();
  const currentSettlement = values.settlement;
  const totalDiscounts = values.settlement.settlementBalancesAttributes.reduce((acc, current) => {
    return acc + +current.amount;
  }, 0);
  const assetsAmount = currentSettlement?.totalAmount || 0;
  const totalToPay = assetsAmount - totalDiscounts;
  const parsedTotal = new Intl.NumberFormat('es-CL').format(totalToPay);
  return (
    <>
      <Row className="summary__balances_header small">
        <Col md={6} className="">
          <strong>Total a Pagar</strong>
        </Col>
        <Col className="col-1 " />
      </Row>
      <Row>
        <Col xl={11} xs={12} className="d-flex p-0">
          <Col xl={3} md={3} lg={3} xs={12}>
            <FormikInput label="" value={parsedTotal} style={{ minWidth: '65px' }} disabled />
          </Col>
        </Col>
      </Row>
    </>
  );
}
